const getRequiredSchemas = (searchProperties, {
  id,
  properties = {},
  dynamicProperties = {},
  relations = []
} = {}) => [id, ...searchProperties.map(property => {
  if (!property) return null;
  const fieldParts = property.split('.');
  const [localFieldPart] = property.split('.');
  if (fieldParts.length === 1 || properties[localFieldPart] || dynamicProperties[localFieldPart]) {
    return null;
  }
  const matchingRelation = relations.find(({
    localField
  }) => localField === localFieldPart);
  if (!matchingRelation) return null;
  return matchingRelation.entityIdentifier;
})].filter(Boolean);
export default getRequiredSchemas;
//# sourceMappingURL=get-required-schemas.js.map